import { identityServiceApi } from '../../../../infra/identityApi.service';
import { ADMINISTRATION_API } from '../../../../common/constants/api';

export const searchByCounties = async (value) => {
    try {
        const res = await identityServiceApi({
            method: 'get',
            url: `${ADMINISTRATION_API.COUNTIES}?name=${value}`,
        });

        return {
            result: true,
            options: res.data,
        };
    } catch (e) {
        return {
            error: `Get counties: ${e.message}`,
        };
    }
};



// WEBPACK FOOTER //
// ./src/modules/Leads/Lead_profile/requests/search_by_counties_request.js